import React from 'react';
import { BuildingIcon, HandshakeIcon, ShieldCheckIcon, TrendingUpIcon } from 'lucide-react';
import { expertise } from '../data/profile';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
const icons = {
  handshake: HandshakeIcon,
  building: BuildingIcon,
  trending: TrendingUpIcon,
  shield: ShieldCheckIcon
};
export function ExpertiseGrid({
  showLabel = true
}: {
  showLabel?: boolean;
}) {
  return <section id="expertise" className="w-full border-t border-line bg-white py-20 lg:py-28" data-id="element-266" data-mp="3dhs9s6coaahr">
      <div className="mx-auto max-w-shell px-6 sm:px-8" data-id="element-267" data-mp="3hmi4hrvlhj13">
        {showLabel && <Reveal data-id="element-268" data-mp="33m7bai6tbscr">
            <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-269" data-mp="33mqjv8akp4e4">
              <div data-id="element-270" data-mp="38ksd2m1pqk3b">
                <SectionLabel data-id="element-271" data-mp="38mcxvjy86onz">Core Expertise</SectionLabel>
                <h2 className="mt-6 max-w-xl font-serif text-[32px] font-semibold leading-[1.12] tracking-[-0.015em] text-navy sm:text-4xl lg:text-[44px]" data-id="element-272" data-mp="11uuao5bvo6mi">
                  Four disciplines, governed as one mandate
                </h2>
              </div>
              <p className="max-w-sm text-[15px] leading-relaxed text-charcoal-muted" data-id="element-273" data-mp="1iv4t1o65rwlr">
                Procurement, real estate, transformation, and risk — each owned end to end across
                strategy, budget, and the teams delivering it in 45+ countries.
              </p>
            </div>
          </Reveal>}

        <div className={`grid grid-cols-1 gap-x-14 gap-y-12 md:grid-cols-2 ${showLabel ? 'mt-14' : ''}`} data-id="element-274" data-mp="14uk92ooibuqo">
          {expertise.map((area, index) => {
          const Icon = icons[area.icon];
          return <Reveal key={area.title} delay={index * 0.06} as="article" className="h-full" data-id="element-275" data-mp="1dtntpx3boi7a" data-mpi={index}>
                <div className="group flex h-full flex-col border-t border-navy/15 pt-8" data-id="element-276" data-mp="18z1t8oys4a1z">
                  <span className="flex h-11 w-11 items-center justify-center bg-navy transition-colors duration-200 ease-premium group-hover:bg-metal" data-id="element-277" data-mp="2p9cjsxbvhxcb">
                    <Icon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-278" data-mp="1hzher3powqgz" />
                  </span>
                  <h3 className="mt-6 font-serif text-[24px] font-semibold leading-tight tracking-[-0.01em] text-navy lg:text-[26px]" data-id="element-279" data-mp="1mwzrl56tvpu9">
                    {area.title}
                  </h3>
                  <p className="mt-4 text-[15px] leading-[1.7] text-charcoal-light" data-id="element-280" data-mp="1vyz6nrya8juk">
                    {area.description}
                  </p>
                  <ul className="mt-auto flex flex-wrap gap-x-5 gap-y-2 pt-7" data-id="element-281" data-mp="za1dufa3ew01">
                    {area.points.map(point => <li key={point} className="text-[12px] font-medium uppercase tracking-[0.1em] text-charcoal-muted" data-id="element-282" data-mp="188v47nwtyq55">
                        {point}
                      </li>)}
                  </ul>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}